import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "../../config";
import { Button, Table, Input, Select } from "antd";
import authHeader from "../Authentication/authHeader";
import { render } from "@testing-library/react";
import Swal from "sweetalert2";

export default function RegularCustomer() {
  const { Option } = Select;
  const [regularCustomerList, setRegularCustomerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [regularCountData, setRegularCountData] = useState({});
  const [regularFilterData, setRegularFilterData] = useState("all");
  const { Search } = Input;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState("");
  const [centerList, setCenterList] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState("");

  const fetchRegularCustomerList = async () => {
    setLoading(true);
    await axios
      .get(`${config.baseUrl}/inventory/rcList/`, {
        headers: authHeader(),
        params: {
          page: currentPage,
          filter: filter,
          centerName: selectedCenter,
        },
      })
      .then((results) => {
        setRegularCustomerList(results?.data.results || []);
        setTotalItems(results?.data.count || 0);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/rcCount/${regularFilterData}/`, {
        headers: authHeader(),
      })
      .then((results) => {
        setRegularCountData(results?.data);
      });
  }, [regularFilterData]);

  useEffect(() => {
    fetchRegularCustomerList()
  }, [currentPage, filter, selectedCenter]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const regularDistrictValue = (value) => {
    setRegularFilterData(value);
  };
  const handleCenterFilter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handleFilterChange = (value) => {
    setCurrentPage(1);
    setFilter(value);
  };

  const columns = [
    {
      title: "Customer ID",
      dataIndex: "customer_id",
      width: "15%",
    },
    {
      title: "Regular Customer",
      dataIndex: "name",
      width: "15%",
    },
    {
      title: "Center",
      render: (record) => record?.center?.center_name,
      width: "15%",
    },
    {
      title: "Phone",
      dataIndex: "phone",

      width: "14%",
      render: (text) => {
        return "0" + text;
      },
    },
    {
      title: "District",
      render: (record) => record?.district?.district_name,
      width: "24%",
    },
    {
      title: "Address",
      render: (record) => record?.address,
      width: "24%",
    },
  ];

  return (
    <div className="farmerDashboard">
      <div className="dashboardNameSection">
        <h5 style={{ color: "#46604A" }}>REGULAR CUSTOMER DASHBOARD</h5>
      </div>
      <div className="farmerDashboardContainer shadow-sm rounded">
        <div className="farmerBoxSection">
          <div className="farmerCardDesign">
            <p className="m-3" style={{ fontSize: "18px" }}>
              Total Registered Regular Customer
            </p>
            <p className="m-3" style={{ fontSize: "30px" }}>
              {regularCountData?.total_count || 0}
            </p>
          </div>
          <div className="farmerCardDesign">
            <p className="mt-3 ms-3">District Filter:</p>
            <Select
              className="ms-3 w-50"
              name="Select"
              onChange={regularDistrictValue}
              placeholder="Select District"
              showSearch
            >
              <Option value="all">District</Option>
              {regularCountData?.district_values?.map((item, index) => (
                <Option key={index} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
          <Select
            className="w-25"
            name="Select"
            onChange={handleCenterFilter}
            placeholder="Select Center"
            showSearch
          >
            <Option value="">All</Option>
            {centerList?.map((center) => (
              <Option key={center?.id} value={center?.center_name}>
                {center?.center_name}
              </Option>
            ))}
          </Select>
          <Search
            className="w-25"
            placeholder="search here..."
            allowClear
            onSearch={handleFilterChange}
            enterButton={
              <Button
                style={{
                  backgroundColor: "#46604A",
                  borderColor: "#46604A",
                  color: "white",
                }}
              >
                Search
              </Button>
            }
          />
        </div>
        <div className="m-2 border">
          <Table
            columns={columns}
            size="small"
            dataSource={regularCustomerList}
            loading={loading}
            rowKey={(record) => record.customer_id}
            pagination={{
              current: currentPage,
              total: totalItems,
              pageSize: 10,
              onChange: handlePageChange,
            }}
          />
        </div>
      </div>
    </div>
  );
}
